/**
 * Fime – Key Challenges section (Industries template)
 *
 * 1. Desktop: hovering a tab swaps the active title/text, read
 *    directly from that tab's own data-title/data-text attributes
 *    (rendered server-side by Twig) rather than a separate hardcoded
 *    JS array — single source of truth, so this never drifts out of
 *    sync with the actual tab content once it becomes ACF-driven.
 * 2. Mobile/tablet: accordion, click to expand, one open at a time.
 */

const challengeTabs = document.querySelectorAll('.challenge-tab');
const challengeTitle = document.getElementById('challenge-active-title');
const challengeText = document.getElementById('challenge-active-text');

challengeTabs.forEach(function (tab) {
	tab.addEventListener('mouseenter', function () {
		if (!challengeTitle || !challengeText) return;

		challengeTabs.forEach(function (t) {
			t.classList.remove('is-active');
		});
		tab.classList.add('is-active');

		challengeTitle.style.opacity = '0';
		challengeText.style.opacity = '0';

		setTimeout(function () {
                        const titleSrc = tab.querySelector('.challenge-tab-title-src');
                        const textSrc = tab.querySelector('.challenge-tab-text-src');
                        challengeTitle.textContent = titleSrc ? titleSrc.textContent : '';
                        challengeText.textContent = textSrc ? textSrc.textContent : '';
                        challengeTitle.style.opacity = '1';
                        challengeText.style.opacity = '1';
                }, 150);
	});
});

const accordionItems = document.querySelectorAll('.challenge-accordion-item');

accordionItems.forEach(function (item) {
	const trigger = item.querySelector('.challenge-accordion-trigger');
	const panel = item.querySelector('.challenge-accordion-panel');

	trigger.addEventListener('click', function () {
		const isOpen = item.classList.contains('is-open');

		accordionItems.forEach(function (otherItem) {
			otherItem.classList.remove('is-open');
			otherItem.querySelector('.challenge-accordion-panel').classList.add('hidden');
		});

		if (!isOpen) {
			item.classList.add('is-open');
			panel.classList.remove('hidden');
		}
	});
});
